module.exports = __webpack_public_path__ + "media/images/ruutz-logo-bw-48f744cb0b88f6861a5aea3de859e3bb.png";